jQuery.feature_import("js_customer_account",
    () => import("./customerInvoiceAccount.js"),
    mod => mod.feature_js_customer_account
);